import { api, unwrap } from './client';

/* Asset endpoints return ApiResponse<T> — use unwrap(). */

export async function listAssets(page = 0, size = 10) {
  const res = await api.get(`/finance/assets/paginated/all?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listMyAssignedAssets() {
  const res = await api.get('/finance/assets/assigned');
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listAvailableAssets() {
  const res = await api.get('/finance/assets/available');
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listAssetsByStatus(status, page = 0, size = 10) {
  const res = await api.get(`/finance/assets/paginated/status/${status}?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listAssetsByUser(username, page = 0, size = 10) {
  const res = await api.get(`/finance/assets/paginated/user/${username}?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function getAsset(id) {
  const res = await api.get(`/finance/assets/${id}`);
  return unwrap(res);
}

export async function createAsset(payload) {
  const res = await api.post('/finance/assets', payload);
  return unwrap(res);
}

export async function updateAsset(id, payload) {
  const res = await api.put(`/finance/assets/${id}`, payload);
  return unwrap(res);
}

export async function assignAsset(id, userId) {
  const res = await api.put(`/finance/assets/${id}/assign/${userId}`);
  return unwrap(res);
}

export async function unassignAsset(id) {
  const res = await api.put(`/finance/assets/${id}/unassign`);
  return unwrap(res);
}

export async function deleteAsset(id) {
  const res = await api.delete(`/finance/assets/${id}`);
  return unwrap(res);
}
